import { render, staticRenderFns } from "./SubsidiariesTable.vue?vue&type=template&id=03bb217f&"
import script from "./SubsidiariesTable.vue?vue&type=script&lang=js&"
export * from "./SubsidiariesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports